module.exports = {"title":"Item Invoice","copy":"Generate an invoice that you can customize and print.","cta":"View Invoice","calloutCopy":{"header":"Exclusive Trade Feature","text":"Instantly display a formal quote for any item you are considering."}}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/DetailsInvoice.json
// module id = 1827
// module chunks = 4 14